import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { useBulkFilter } from './useBulkFilter';
import { BulkRequestTypeEnum, isBulkRequestType } from './BulkRequestTypeEnum';

interface HookReturn {
  bulkRequestType: BulkRequestTypeEnum | null;
}

export const useBulkInit = (): HookReturn => {
  const [,, resetFilter] = useBulkFilter();
  const [search] = useSearchParams();
  const navigate = useNavigate();

  const operation = search.get('operation');

  const bulkRequestType = useMemo(() => {
    return isBulkRequestType(operation) ? operation : null;
  }, [operation]);

  useEffect(() => {
    if (!operation) {
      // Invalid bulk operation comes from the query params, navigate back
      navigate(-1);
    } else {
      // Trigger initial load for the data
      resetFilter();
    }
  }, [resetFilter, bulkRequestType, operation, navigate]);

  return { bulkRequestType };
};
